(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["half-image-benefits-email"]) return;
  try {
    
  (() => {
    const newsletterSignupForm = document.querySelector('#home-signup form.newsletter-signup__form');
    newsletterSignupForm.addEventListener('submit', event => {
      event.preventDefault();

      // Show successful signup element, regardless of whether or not it actually was successful
      const signupSuccess = document.querySelector('#home-signup div.newsletter-signup__success');
      newsletterSignupForm.style.display = 'none';
      signupSuccess.style.display = 'block';

      const email = event.target[1].value;
      const data = {
        form_type: 'customer',
        'contact[email]': email,
      };

      const url = '/contact#contact_form';

      fetch(url, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      return false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrb-assembly-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGuide(root) {
      if (!root || root.__lrbAgInit) return;
      root.__lrbAgInit = true;
      var total = parseInt(root.getAttribute('data-total'), 10) || 0;
      var storageKey = root.getAttribute('data-storage-key') || 'lrb-ag';
      var stepBtns = Array.prototype.slice.call(root.querySelectorAll('[data-ag-step]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ag-panel]'));
      var donePanel = root.querySelector('[data-ag-done]');
      var fill = root.querySelector('[data-ag-fill]');
      var bar = root.querySelector('[data-ag-bar]');
      var countEl = root.querySelector('[data-ag-count]');
      var labelEl = root.querySelector('[data-ag-label]');
      var current = 0;
      var completed = {};
      try {
        var saved = JSON.parse(localStorage.getItem(storageKey) || '{}');
        if (saved && saved.completed) {
          saved.completed.forEach(function (i) {
            if (i >= 0 && i < total) completed[i] = true;
          });
        }
        if (saved && typeof saved.current === 'number' && saved.current >= 0 && saved.current < total) {
          current = saved.current;
        }
      } catch (e) {}
      function save() {
        try {
          var arr = [];
          for (var k in completed) {
            if (completed[k]) arr.push(parseInt(k, 10));
          }
          localStorage.setItem(storageKey, JSON.stringify({ completed: arr, current: current }));
        } catch (e) {}
      }
      function doneCount() {
        var n = 0;
        for (var k in completed) {
          if (completed[k]) n++;
        }
        return n;
      }
      function renderProgress() {
        var c = doneCount();
        var pct = total ? Math.round((c / total) * 100) : 0;
        if (fill) fill.style.width = pct + '%';
        if (bar) bar.setAttribute('aria-valuenow', c);
        if (countEl) countEl.textContent = c;
        if (labelEl) {
          labelEl.textContent =
            c === 0 ? 'Not started yet' : c >= total ? 'All steps complete 🎉' : 'steps done, keep going';
        }
        stepBtns.forEach(function (b) {
          var i = parseInt(b.getAttribute('data-ag-step'), 10);
          b.classList.toggle('is-done', !!completed[i]);
        });
        root.classList.toggle('is-complete', total > 0 && c >= total);
      }
      function syncToggles() {
        panels.forEach(function (p) {
          var i = parseInt(p.getAttribute('data-ag-panel'), 10);
          var tg = p.querySelector('[data-ag-toggle]');
          if (!tg) return;
          var on = !!completed[i];
          tg.classList.toggle('is-done', on);
          tg.setAttribute('aria-pressed', on ? 'true' : 'false');
          var lbl = tg.querySelector('[data-ag-toggle-label]');
          if (lbl) lbl.textContent = on ? 'Completed' : tg.getAttribute('data-label') || 'Mark done';
        });
      }
      var mqMobile = window.matchMedia('(max-width: 900px)');
      function showAll() {
        // Mobile: every step panel visible and stacked; no single-step / completion view.
        panels.forEach(function (p) {
          p.hidden = false;
        });
        if (donePanel) donePanel.hidden = true;
        stepBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-current', 'false');
        });
      }
      function showStep(i) {
        if (mqMobile.matches) {
          showAll();
          return;
        }
        if (i < 0) i = 0;
        if (i > total - 1) i = total - 1;
        current = i;
        panels.forEach(function (p) {
          p.hidden = parseInt(p.getAttribute('data-ag-panel'), 10) !== i;
        });
        if (donePanel) donePanel.hidden = true;
        stepBtns.forEach(function (b) {
          var on = parseInt(b.getAttribute('data-ag-step'), 10) === i;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-current', on ? 'step' : 'false');
        });
        save();
      }
      function showDone() {
        if (mqMobile.matches) return;
        panels.forEach(function (p) {
          p.hidden = true;
        });
        stepBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-current', 'false');
        });
        if (donePanel) donePanel.hidden = false;
      }
      function layout() {
        if (mqMobile.matches) {
          showAll();
        } else {
          showStep(current);
        }
      }
      stepBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          showStep(parseInt(b.getAttribute('data-ag-step'), 10));
        });
      });
      root.addEventListener('click', function (e) {
        var t = e.target.closest('[data-ag-next],[data-ag-prev],[data-ag-toggle],[data-ag-review]');
        if (!t || !root.contains(t)) return;
        if (t.hasAttribute('data-ag-next')) {
          if (current >= total - 1) {
            showDone();
          } else {
            showStep(current + 1);
          }
        } else if (t.hasAttribute('data-ag-prev')) {
          showStep(current - 1);
        } else if (t.hasAttribute('data-ag-toggle')) {
          var tp = t.closest('[data-ag-panel]');
          var ti = tp ? parseInt(tp.getAttribute('data-ag-panel'), 10) : current;
          if (completed[ti]) {
            delete completed[ti];
          } else {
            completed[ti] = true;
          }
          renderProgress();
          syncToggles();
          save();
          if (!mqMobile.matches && completed[ti] && doneCount() >= total && ti >= total - 1) {
            showDone();
          }
        } else if (t.hasAttribute('data-ag-review')) {
          showStep(0);
        }
      });
      root.__lrbAgShow = showStep;
      renderProgress();
      syncToggles();
      if (!mqMobile.matches && total > 0 && doneCount() >= total) {
        showDone();
      } else {
        layout();
      }
      if (mqMobile.addEventListener) {
        mqMobile.addEventListener('change', layout);
      } else if (mqMobile.addListener) {
        mqMobile.addListener(layout);
      }
    }
    function initAll(ctx) {
      var scope = ctx && ctx.querySelectorAll ? ctx : document;
      var nodes = scope.querySelectorAll('[data-lrb-ag]');
      Array.prototype.forEach.call(nodes, initGuide);
      if (ctx && ctx.matches && ctx.matches('[data-lrb-ag]')) initGuide(ctx);
      if (ctx && ctx.querySelector) {
        var inner = ctx.querySelector('[data-lrb-ag]');
        if (inner) initGuide(inner);
      }
    }
    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    }
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest ? e.target.closest('[data-lrb-ag]') : null;
      if (!root || !root.__lrbAgShow) return;
      var panel = e.target.matches('[data-ag-panel]') ? e.target : e.target.querySelector('[data-ag-panel]');
      if (panel) root.__lrbAgShow(parseInt(panel.getAttribute('data-ag-panel'), 10));
    });
  })();

  // Branded video poster: click to reveal + play the video.
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-lrb-vid-play]') : null;
      if (!btn) return;
      var wrap = btn.closest('[data-lrb-vid]');
      var vid = wrap && wrap.querySelector('video');
      if (vid) {
        btn.setAttribute('hidden', '');
        try {
          vid.play();
        } catch (err) {}
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrb-page-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Resolve a "#key" link to the real element: the inner id, the Shopify
    // section wrapper (shopify-section-<id>), or a prefixed wrapper (…__<id>).
    function resolveTarget(raw) {
      if (!raw) return null;
      var id = raw.charAt(0) === '#' ? raw.slice(1) : raw;
      if (!id) return null;
      return (
        document.getElementById(id) ||
        document.getElementById('shopify-section-' + id) ||
        document.querySelector('[id$="__' + id + '"]')
      );
    }

    // Measure any fixed/sticky header pinned to the top so we don't scroll the
    // target underneath it.
    function headerOffset() {
      var max = 0;
      var els = document.querySelectorAll(
        'header, [class*="header" i], [id*="header" i], [class*="announcement" i], [class*="topbar" i], [class*="top-bar" i]'
      );
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var cs = window.getComputedStyle(el);
        if (cs.position === 'fixed' || cs.position === 'sticky') {
          var r = el.getBoundingClientRect();
          if (r.top <= 2 && r.height > 0 && r.height < 260 && r.width > window.innerWidth * 0.6) {
            if (r.bottom > max) max = r.bottom;
          }
        }
      }
      return max;
    }

    function scrollToTarget(target) {
      var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 14;
      window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
    }

    function initNav(root) {
      if (!root || root.__lrbNavInit) return;
      root.__lrbNavInit = true;

      var links = Array.prototype.slice.call(root.querySelectorAll('[data-lrb-nav-link]'));
      if (!links.length) return;

      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          var href = a.getAttribute('href');
          var target = resolveTarget(href);
          if (target) {
            e.preventDefault();
            scrollToTarget(target);
            if (history.replaceState) history.replaceState(null, '', href);
          }
        });
      });

      // Highlight the section currently in view.
      if (!('IntersectionObserver' in window)) return;
      var map = {};
      var targets = [];
      links.forEach(function (a) {
        var el = resolveTarget(a.getAttribute('href'));
        if (el) {
          var key = el.id || a.getAttribute('href');
          el.setAttribute('data-lrb-nav-key', key);
          map[key] = a;
          targets.push(el);
        }
      });
      var current = null;
      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var key = entry.target.getAttribute('data-lrb-nav-key');
              if (current && map[current]) map[current].classList.remove('is-current');
              if (map[key]) {
                map[key].classList.add('is-current');
                current = key;
              }
            }
          });
        },
        { rootMargin: '-45% 0px -50% 0px', threshold: 0 }
      );
      targets.forEach(function (t) {
        obs.observe(t);
      });
    }

    function initAll(ctx) {
      var scope = ctx && ctx.querySelectorAll ? ctx : document;
      scope.querySelectorAll('[data-lrb-nav]').forEach(initNav);
      if (ctx && ctx.matches && ctx.matches('[data-lrb-nav]')) initNav(ctx);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    }
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrb-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ytId(url) {
      if (!url) return null;
      var m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/))([\w-]{6,})/);
      if (m) return m[1];
      m = url.match(/[?&]v=([\w-]{6,})/);
      return m ? m[1] : null;
    }
    function initRp(root) {
      if (!root || root.__lrbRpInit) return;
      root.__lrbRpInit = true;
      var modal = root.querySelector('[data-lrb-rp-modal]');
      var frame = root.querySelector('[data-lrb-rp-frame]');
      if (!modal || !frame) return;

      function open(url) {
        var id = ytId(url);
        frame.src = id ? 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0' : url;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }
      function close() {
        modal.hidden = true;
        frame.src = '';
        document.documentElement.style.overflow = '';
      }

      root.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-lrb-rp-video]');
        if (trigger && root.contains(trigger)) {
          e.preventDefault();
          open(trigger.getAttribute('data-lrb-rp-video'));
          return;
        }
        if (e.target.closest('[data-lrb-rp-close]')) {
          close();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    }
    function initAll(ctx) {
      var scope = ctx && ctx.querySelectorAll ? ctx : document;
      scope.querySelectorAll('[data-lrb-rp]').forEach(initRp);
      if (ctx && ctx.matches && ctx.matches('[data-lrb-rp]')) initRp(ctx);
    }
    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    }
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrb-workouts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-lrb-wk-play]') : null;
      if (!btn) return;
      var wrap = btn.closest('[data-lrb-wk-vid]');
      var vid = wrap && wrap.querySelector('video');
      if (vid) {
        btn.setAttribute('hidden', '');
        try {
          vid.play();
        } catch (err) {}
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["try-our-trampolines"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function scrollToProduct() {
      const productElement = document.querySelector('div.product-container');
      const navbarHeight = document.querySelector('header.navbar-container').offsetHeight;
      const y = productElement.offsetTop - navbarHeight;
      window.scroll({
        top: y,
        behavior: 'smooth',
      });
    }

    const buttonElement = document.querySelector('section.try-our-trampolines .button.primary');
    buttonElement.onclick = e => {
      if (window.location.href.indexOf('/products/bungee-rebounders-mini-trampoline') > -1) {
        e.preventDefault();
        scrollToProduct();
      }
    };
  })();

  } catch(e) { console.error(e); }
})();
})();
